<template>
    <div>
        test
    </div>
</template>

<script>
    export default {
        name: 'mock',
    };
</script>
